function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "file-2");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "file-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "file-2",
  transform: "translate(0.519531, 0.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 2.13605664,
  y: 2.125,
  width: 3.54167773,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 2.13605664,
  y: 3.54167773,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 3.55273438,
  y: 3.54167773,
  width: 1,
  height: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3656191,2.93711523 L10.5322969,0.103759766 C10.4658906,0.0373535156 10.3758105,0 10.2819121,0 L1.07355664,0 C0.486757812,0 0.0110566406,0.475701172 0.0110566406,1.0625 L0.0110566406,15.9375 C0.0110566406,16.5242988 0.486757812,17 1.07355664,17 L12.4068789,17 C12.9936777,17 13.4693789,16.5242988 13.4693789,15.9375 L13.4693789,3.1875 C13.4693789,3.09356836 13.4320586,3.00352148 13.3656191,2.93711523 Z M12.7610566,15.9375 C12.7610566,16.1330996 12.6024785,16.2916777 12.4068789,16.2916777 L1.07355664,16.2916777 C0.877957031,16.2916777 0.719378906,16.1330996 0.719378906,15.9375 L0.719378906,1.0625 C0.719378906,0.866900391 0.877957031,0.708322266 1.07355664,0.708322266 L10.1352539,0.708322266 L12.7610566,3.334125 L12.7610566,15.9375 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9902344,2.83332227 C10.7946348,2.83332227 10.6360566,2.67474414 10.6360566,2.47914453 L10.6360566,0.354144531 L9.92773438,0.354144531 L9.92773438,2.47914453 C9.92773438,3.06594336 10.4034355,3.54164453 10.9902344,3.54164453 L11.6985566,3.54164453 L11.6985566,2.83332227 L10.9902344,2.83332227 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.51105664,13.1041777 L8.51105664,13.8125 L2.84441211,13.8125 L2.84441211,8.85417773 L3.55273438,8.85417773 L3.55273438,8.14585547 L2.84441211,8.14585547 C2.45321289,8.14585547 2.13608984,8.46297852 2.13608984,8.85417773 L2.13608984,13.8125 C2.13608984,14.2036992 2.45321289,14.5208223 2.84441211,14.5208223 L8.51108984,14.5208223 C8.90228906,14.5208223 9.21941211,14.2036992 9.21941211,13.8125 L9.21941211,13.1041777 L8.51105664,13.1041777 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6360566,6.02082227 L4.96941211,6.02082227 C4.57821289,6.02082227 4.26108984,6.33794531 4.26108984,6.72914453 L4.26108984,11.6875 C4.26108984,12.0786992 4.57821289,12.3958223 4.96941211,12.3958223 L10.6360898,12.3958223 C11.0272891,12.3958223 11.3444121,12.0786992 11.3444121,11.6875 L11.3444121,6.72917773 C11.3444121,6.33797852 11.0272559,6.02082227 10.6360566,6.02082227 Z M10.6360898,11.6875 L4.96941211,11.6875 L4.96941211,6.72917773 L10.6360898,6.72917773 L10.6360898,11.6875 Z",
  id: "Shape"
})));

var SvgFile2 = function SvgFile2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFile2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file2.0a745dd4.svg";
export { ForwardRef as ReactComponent };